import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Dashboard footer — matches reference layout (copyright left, links right).
 */
export default function AppFooter() {
  const year = new Date().getFullYear();
  return (
    <footer className="app-footer shrink-0">
      <div className="app-footer__inner">
        <p className="app-footer__copy">
          © {year} Stavyn. All rights reserved.
        </p>
        <nav className="app-footer__links" aria-label="Legal">
          <Link to="/privacy">Privacy Policy</Link>
          <Link to="/terms">Terms of Service</Link>
          <a href="mailto:hello@stavyn.com">Support</a>
        </nav>
      </div>
    </footer>
  );
}
